export const LOCALES = ['en', 'bg'] as const;
export type Locale = (typeof LOCALES)[number];

/** Intl locale per UI language. Euro amounts follow the language's conventions. */
export const INTL_LOCALE: Record<Locale, string> = { en: 'en-IE', bg: 'bg-BG' };

/** Each language in its own script (not translated). */
export const LANGUAGE_NAME: Record<Locale, string> = { en: 'English', bg: 'Български' };

export function isLocale(value: unknown): value is Locale {
  return value === 'en' || value === 'bg';
}
